import {h, Fragment} from "preact"
import { useAppStateSelector } from '@nosto/preact'
import { useEffect } from 'preact/hooks'

export default function NoResults() {
    const query = useAppStateSelector((state) => state.response.query)

    useEffect(() => {
        nostojs((api) => {
            api.createRecommendationRequest({ includeTagging: true })
                .setElements(['noresults-nosto-1'])
                .load({ skipPageViews: true, skipEvents: true })
        })
    }, [])

    return (
        <div class='ns-my-5'>
            <div>Kokeile muuttaa rajauksia tai poistaa rajauksia</div>
            <div class='nosto-rec-container'>
                <div class='nosto_element' id='noresults-nosto-1'></div>
            </div>
        </div>
    )
}
